__turbopack_context__.v({
  "--1": "photo-scroll-entry-module-scss-module__BJ1AJG__--1",
  "--2": "photo-scroll-entry-module-scss-module__BJ1AJG__--2",
  "--3": "photo-scroll-entry-module-scss-module__BJ1AJG__--3",
  "--is-selected": "photo-scroll-entry-module-scss-module__BJ1AJG__--is-selected",
  "__button-on-image": "photo-scroll-entry-module-scss-module__BJ1AJG____button-on-image",
  "__button-share": "photo-scroll-entry-module-scss-module__BJ1AJG____button-share",
  "__button-vote": "photo-scroll-entry-module-scss-module__BJ1AJG____button-vote",
  "__footer": "photo-scroll-entry-module-scss-module__BJ1AJG____footer",
  "__image": "photo-scroll-entry-module-scss-module__BJ1AJG____image",
  "__image-container": "photo-scroll-entry-module-scss-module__BJ1AJG____image-container",
  "__overlay": "photo-scroll-entry-module-scss-module__BJ1AJG____overlay",
  "__overlay-text": "photo-scroll-entry-module-scss-module__BJ1AJG____overlay-text",
  "__rank-display": "photo-scroll-entry-module-scss-module__BJ1AJG____rank-display",
  "__selected-vote-icon": "photo-scroll-entry-module-scss-module__BJ1AJG____selected-vote-icon",
  "__title": "photo-scroll-entry-module-scss-module__BJ1AJG____title",
  "__title-bar": "photo-scroll-entry-module-scss-module__BJ1AJG____title-bar",
  "photo-scroll-entry": "photo-scroll-entry-module-scss-module__BJ1AJG__photo-scroll-entry",
  "shimmer": "photo-scroll-entry-module-scss-module__BJ1AJG__shimmer",
});
